import React from 'react'
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import UsedRentalsCarsListAPI from '../../../../../API/UsedRentalsCarsListAPI';
import { FormatDate } from '../../../../Utils/GenericFunctions';
import ConfirmationDialog from '../../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../../Utils/SnackbarAlert';
import RUCarOrderReservationsTable from './RUCarOrderReservationsTable';
import { handleServerError, handleSpecialCharacters } from '../../../../../Utils/Helper';
import NOLSSyncAPI from '../../../../../API/NOLSSyncAPI';

const headerData = [
  { id: 'brand', label: 'MARCA' },
  { id: 'model', label: 'MODELO' },
  { id: 'announcedOptionals', label: 'OPCIONAIS ANUNCIADOS' },
  { id: 'color', label: 'COR' },
  { id: 'saleschannels', label: 'CANAIS VENDA' },
  { id: 'licenseplate', label: 'MATRÍCULA' },
  { id: 'licenseplatedate', label: 'DATA MATRÍCULA' }
];

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    padding: 0
  },
  tblRow: {
    height: '30px',
    backgroundColor: '#F2F2F2',
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1'
    }
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: '12px'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  flex: {
    flex: 1
  },
  contentPadding: {
    padding: '0px 32px',
    marginTop: '156px'
  },
  toolbarHeight: {
    minHeight: '52px'
  },
  paddingBorder: {
    padding: '0px 240px',
    borderBottom: '2px solid #007b7a'
  },
  group: {
    display: 'inline-block'
  },
  radioSize: {
    height: '24px',
    width: '24px',
    margin: '2px 4px 2px 8px'
  },
  fabProgress: {
    margin: theme.spacing.unit,
    position: 'absolute',
    right: 18,
    top: -6,
    zIndex: 1
  }
});

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={10}
      fixedDecimalScale
      decimalScale={0}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


class RUCarOrderAssociation extends React.Component {
  l4ListAPI;

  constructor(props) {
    super(props);
    this.state = {
      OrderNumber: '',
      Customer: '',
      DestinationLocal: '',
      CustomerExpectedDeliveryDate: '',
      loading: false,
      success: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      openError: false,
      alertMessage: '',
      ReservationId: 0,
      changedValueDetected: false,
      reservationFilterValue: 'sameCharacteristics'
    };
    this.l4ListAPI = new UsedRentalsCarsListAPI();
  }

  componentDidMount() {
    this.getOrderDetails(this.props.carDetail.OrderNumber);
  }

  componentWillReceiveProps(props) {
    this.setState({
      OrderNumber: props.carDetail.OrderNumber ? props.carDetail.OrderNumber : '',
      Customer: props.carDetail.ClientName ? props.carDetail.ClientName : '',
      CustomerExpectedDeliveryDate: FormatDate(props.carDetail.CustomerExpectedDeliveryDate)
    });
  };

  getOrderDetails = (orderNumber) => {
    const nolsSyncAPI = new NOLSSyncAPI();
    if (orderNumber && this.props.carDetail.Transportation) {
      nolsSyncAPI.sendGetOrderDetailsRuBM(orderNumber).then((response) => {
        this.setState({
          DestinationLocal: response.data && response.data.delivery_location ? response.data.delivery_location : this.props.carDetail.DestinationLocation
        });
      })
    }
  }

  handleClose = () => {
    this.props.handleClose();
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
    this.detectChange();
  };

  handleCheckReservation = (id, customer) => {
    this.setState({
      ReservationId: id,
      Customer: customer
    });
    this.detectChange();
  };

  handleFilterData = event => {
    this.setState({ reservationFilterValue: event.target.value });
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  };

  handleGoBack = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
    this.props.reloadL4Table()
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleConfirmForceSave = () => {
    this.setState({
      loading: false,
      openDialog: true,
      confirmationFunction: () => this.handleSubmitAssociateOrder(true),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitAssociateOrder = (forceSave) => {
    this.setState({ loading: true })
    let carDTO = {
      L4Id: this.props.carDetail.L4ID,
      OrderNumber: this.state.OrderNumber !== '' ? this.state.OrderNumber : 0,
      Customer: this.state.Customer,
      DestinationLocation: this.state.DestinationLocal,
      ReservationId: this.state.ReservationId,
      ForceSave: forceSave
    }
    this.l4ListAPI.associateOrderToCar(carDTO).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
        this.handleClose();
        this.props.reloadL4Table();
      }, 500)
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('sejam alertados') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende ASSOCIAR A ENCOMENDA à viatura?',
          confirmationMessage: 'As viaturas da marca ' + this.props.carModelData.Brand + ' e modelo ' + this.props.carModelData.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis, a associação de encomenda terá impacto sobre as reservas. '
            + handleServerError(error)
        })
        this.handleConfirmForceSave();
      }
      else if (errorMessage.indexOf('viatura já tem uma encomenda associada') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende SOBREPOR A ENCOMENDA à existente?',
          confirmationMessage: 'A viatura da marca ' + this.props.carModelData.Brand + ' e modelo ' + this.props.carModelData.Model +
            ' já possui uma encomenda associada. A confirmação irá sobrepor a encomenda existente.'
        })
        this.handleConfirmForceSave();
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
      }
    });
  };

  renderCarTableHeader() {
    const { classes } = this.props;
    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell key={column.id} padding='none' className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter)}>
              {column.label}
            </TableCell>
          );
        }, this)}
      </TableRow>
    );
  }

  renderCarTableRecords(carInfo, lotInfo) {
    const { classes } = this.props;
    return (
      <TableRow tabIndex={-1} key={carInfo.L4ID} className={classes.tblRow}>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.Brand}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.Model}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.AnnouncedOptionalsDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.ColourDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.SalesChannelsDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInfo.LicensePlate}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {FormatDate(carInfo.LicensePlateDate)}
        </TableCell>
      </TableRow>
    );
  }


  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;

    return (
      <div>

        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight}>
            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack}>
                <ReturnIcon />
              </Button>
            </Tooltip>
            <Typography variant='title' className={classes.flex}>
              ASSOCIAR ENCOMENDA
            </Typography>
            <Tooltip title='Guardar' placement='bottom' >
              <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleSubmitAssociateOrder(false) }}>
                {success ? <CheckIcon /> : <SaveIcon />}
              </Button>
            </Tooltip>
            {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
          </Toolbar>

          <Paper className={classes.tableWrapper}>
            <Table>
              <TableHead className={classes.tblHead}>
                {this.renderCarTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderCarTableRecords(this.props.carDetail, this.props.carModelData)}
              </TableBody>
            </Table>
          </Paper>

        </AppBar>

        <div className={classes.contentPadding}>
          <Grid container spacing={8} className={classes.gridRoot}>
            <Grid item xs={12} sm={this.props.carDetail.Transportation ? 3 : 4}>
              <TextField
                id='orderNumber'
                label='Nº ENCOMENDA'
                fullWidth
                value={this.state.OrderNumber}
                onChange={this.handleChange('OrderNumber')}
                InputProps={{ inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={this.props.carDetail.Transportation ? 3 : 4}>
              <TextField
                id='customer'
                label='CLIENTE'
                fullWidth
                value={this.state.Customer}
                InputProps={{ readOnly: this.state.ReservationId !== 0 ? true : false }}
                onChange={this.handleChange('Customer')}
              />
            </Grid>
            {this.props.carDetail.Transportation ?
              <Grid item xs={12} sm={3}>
                <TextField
                  id='destinationLocal'
                  label='LOCAL DE DESTINO'
                  fullWidth
                  value={this.state.DestinationLocal}
                  InputProps={{ maxLength: 200 }}
                  onChange={this.handleChange('DestinationLocal')}
                />
              </Grid>
              : null}
            <Grid item xs={12} sm={this.props.carDetail.Transportation ? 3 : 4}>
              <TextField
                id='customerExpectedDeliveryDate'
                label='DATA ENTREGA PRETENDIDA PELO CLIENTE'
                fullWidth
                value={this.state.CustomerExpectedDeliveryDate}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
          <React.Fragment>
            <Grid key={'0'} container>
              <Grid item xs={12} sm={12}>
                <Grid container justify='center'>
                  <Grid item className={classes.paddingBorder}>
                    <FormControl component='fieldset' >
                      <RadioGroup
                        name='reservationFilterValue'
                        className={classes.group}
                        value={this.state.reservationFilterValue}
                        onChange={this.handleFilterData}
                      >
                        <FormControlLabel name='sameCharacteristics' value='sameCharacteristics' control={<Radio classes={{ root: classes.radioSize }} color='primary' />} label='MESMAS CARACTERÍSTICAS' />
                        <FormControlLabel name='allReservations' value='allReservations' control={<Radio classes={{ root: classes.radioSize }} color='primary' />} label='TODAS' />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <RUCarOrderReservationsTable key={'1'} reservationFilterValue={this.state.reservationFilterValue} handleCheckReservation={this.handleCheckReservation.bind(this)} carBrandModel={this.props.carModelData} carDetail={this.props.carDetail} />
          </React.Fragment>
        </div>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={loading}
            success={success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

RUCarOrderAssociation.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RUCarOrderAssociation);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/UsedRentalsCarsList/UsedRentalsCarOrdering/RUCarOrderAssociation.js